import { useSelector } from "react-redux"
import { RootState } from "../app/store"
import { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import type { Project } from "../lib/types"
import BeInTouch from "../components/BeInTouch"
import Modal from "../components/Modal"
import SkeletonImage from "../components/SkeletonImage"
import Footer from "../components/Footer/Footer"

import { Helmet } from "react-helmet"

const Projects = () => {
  const projects = useSelector((state: RootState) => state.projects.items)
  const [searchParams, setSearchParams] = useSearchParams()
  const [visible, setVisible] = useState(false)
  const [modalData, setModalData] = useState<Project | null>(null)

  useEffect(() => {
    const projectSlug = searchParams.get("slug")
    if (projectSlug && projects.length > 0) {
      const project = projects.find((p) => p.slug === projectSlug)
      if (project) {
        setModalData(project)
        setVisible(true)
      }
    }
  }, [searchParams, projects])

  if (visible) {
    document.body.style.overflow = "hidden"
  } else document.body.style.overflow = "unset"

  const handleClcik = (project: Project) => {
    setModalData(project)
    setVisible(true)
    setSearchParams({ slug: project.slug })
  }
  const handleClose = () => {
    setVisible(false)
    setSearchParams({})
  }
  const handleNext = () => {
    if (!modalData) return
    const currentIndex = projects.findIndex((p) => p.id === modalData.id)
    const nextIndex = (currentIndex + 1) % projects.length
    const nextProject = projects[nextIndex]
    setModalData(nextProject)
    setSearchParams({ slug: nextProject.slug })
  }
  const handlePrev = () => {
    if (!modalData) return
    const currentIndex = projects.findIndex((p) => p.id === modalData.id)
    const prevIndex = (currentIndex - 1 + projects.length) % projects.length
    const prevProject = projects[prevIndex]
    setModalData(prevProject)
    setSearchParams({ slug: prevProject.slug })
  }
  return (
    <>
      <Helmet>
        <title>Projects | Muhammed Mashady Portfolio</title>
        <meta
          name="description"
          content="Explore a diverse range of projects including web applications, mobile apps, and backend systems built by Muhammed Mashady."
        />
        <meta property="og:title" content="Projects | Muhammed Mashady" />
        <meta property="og:description" content="Explore a diverse range of projects including web applications, mobile apps, and backend systems." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div className="relative">
        <section
          className={`max-w-[1240px] mx-auto pt-12 px-4 ${
            visible && "overflow-hidden"
          }`}
        >
          <div className="mb-16">
            <div>
              <h1 className="text-3xl font-bold leading-7 sm:truncate   ">
                Projects 🔥
              </h1>

              <p className="text-[22px] md:text-[24px] mt-5">
                As a dedicated software developer, I've had the privilege of
                working on a diverse range of projects that showcase my passion
                for creating innovative solutions. These endeavors include
                developing web applications, mobile apps, and backend systems.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 my-10 gap-10 justify-between ">
              {projects.map((project) => (
                <div
                  className=" rounded "
                  key={project.id}
                  style={{ backgroundColor: "" }}
                >
                  <div className="flex flex-col">
                    <div className="relative rounded-md overflow-hidden aspect-[4/3]">
                      <SkeletonImage
                        src={project.cover}
                        alt={project.name}
                        className="w-full h-full object-cover shadow-lg cursor-pointer"
                        onClick={() => handleClcik(project)}
                      />
                    </div>
                    <div className="flex items-center justify-between mt-2">
                      <h4
                        className="text-2xl ubuntu-bold cursor-pointer"
                        onClick={() => handleClcik(project)}
                      >
                        {project.name}
                      </h4>
                      {/* {project.projectType && (
                        <span className="text-[10px] font-bold px-2 py-1 bg-green-600/20 text-green-400 rounded uppercase tracking-tighter">
                          {project.projectType}
                        </span>
                      )} */}
                    </div>
                    <p className="mt-2 text-nowrap overflow-hidden truncate ">
                      {project.description}
                    </p>
                    <div className="mt-5 flex items-center justify-between gap-2">
                      {project.link ? (
                        <a
                          href={project.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#6b69f2" }}
                          className="ubuntu-bold underline"
                        >
                          Github repo
                        </a>
                      ) : (
                        <span className="text-gray-400">No repo</span>
                      )}
                      {project.demoLink ? (
                        <a
                          href={project.demoLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#6b69f2" }}
                          className="ubuntu-bold"
                        >
                          Live demo
                        </a>
                      ) : (
                        <span className="text-gray-400">No demo</span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <hr className="border-[#79747b]" />
          <BeInTouch />
        </section>
      </div>
      <Modal
        visible={visible}
        modalData={modalData}
        handleClose={handleClose}
        onNext={handleNext}
        onPrev={handlePrev}
      />
      <Footer />
    </>
  )
}

export default Projects
